import la_mas_heavy from './la_mas_heavy.js';
import la_mas_rock_and_roll from './la_mas_rock_and_roll.js';
import la_mas_pop from './la_mas_pop.js';

import muy_pop from './muy_pop.js';
import muy_rock_and_roll from './muy_rock_and_roll.js';
import muy_heavy from './muy_heavy.js';
import muy_rock from './muy_rock.js';

export default {
    la_mas_heavy,
    la_mas_rock_and_roll,
    muy_pop,
    muy_rock_and_roll,
    muy_heavy,
    muy_rock,
    la_mas_pop,
};

